<template>
	<div id="Inventory" class="inventory">
		<div v-if="!loadingInventories">
			<ul class="nav nav-tabs" id="myTab" role="tablist">
				<li class="nav-item" role="presentation">
					<button class="nav-link active" id="template-tab" data-toggle="tab" data-target="#template" type="button" role="tab" aria-controls="template" aria-selected="true">Planillas</button>
				</li>
				<li class="nav-item" role="presentation">
					<button class="nav-link" id="detail-tab" data-toggle="tab" data-target="#detail" type="button" role="tab" aria-controls="product" aria-selected="false">Detalle</button>
				</li>
				<li class="nav-item" role="presentation">
					<button class="nav-link" id="resume-tab" data-toggle="tab" data-target="#resume" type="button" role="tab" aria-controls="product" aria-selected="false">Resumen</button>
				</li>
			</ul>
			<div class="tab-content mt-2" id="myTabContent">
				<div class="tab-pane fade show active" id="template" role="tabpanel" aria-labelledby="template-tab">
					<list-inventory-template-component ref="listInventoryTemplateComponent" :inventoryId="id" :disabled="!(this.objectInventory.status_id == 65)" :search="search"></list-inventory-template-component>
				</div>
				<div class="tab-pane fade" id="detail" role="tabpanel" aria-labelledby="detail-tab">
					<list-inventory-template-detail-component ref="listInventoryTemplateDetailComponent" :inventoryId="id" :disabled="!(this.objectInventory.status_id == 65)"></list-inventory-template-detail-component>
				</div>
				<div class="tab-pane fade" id="resume" role="tabpanel" aria-labelledby="resume-tab">
					<list-inventory-resume-component ref="listInventoryResumeComponent" :inventoryId="id"></list-inventory-resume-component>
				</div>
			</div>
		</div>
		<div v-else class="text-center">
			Buscando Inventario...
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import inventories from '@/mixins/inventories'

	import InventoryRunComponent from '@/components/InventoryRunComponent.vue'
	import ListInventoryTemplateComponent from '@/components/ListInventoryTemplateComponent.vue'
	import ListInventoryTemplateDetailComponent from '@/components/ListInventoryTemplateDetailComponent.vue'
	import ListInventoryResumeComponent from '@/components/ListInventoryResumeComponent.vue'

	export default {
		name: 'Inventory',
		mixins: [axiosAction, errors, mixin, inventories],
		props: ['id'],
		data() {
			return {
				search: ''
			}
		},
		computed: {
		},
		methods: {
			initComponenetLocal() {
				this.setTitleModule('Inventario')
				this.setSubTitleModule('Buscando...')
				this.setComponentLocal()
			},
			getAllInventoriesResultLocal(response) {},
			getAllInventorieTemplatesLocal() {
				this.$refs.listInventoryTemplateComponent.$refs.btnSetComponentLocal.click()
			}, 
			resultAxiosLocal(responseLocal, response) {
				switch(responseLocal) {
					case 'showInventoryResult': this.showInventoryResult(response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
				this.$emit('hideLockScreen')
			},
			setComponentLocal() {
				this.showInventory(this.id)
			},
			showInventoryResultLocal(response) {
				if(this.objectInventory.id > 0) {
					this.setTitleModule(this.objectInventory.description)
					this.setSubTitleModule('')
				}
			}
		},
		components: {
			'inventory-run-component': InventoryRunComponent,
			'list-inventory-template-component': ListInventoryTemplateComponent,
			'list-inventory-template-detail-component': ListInventoryTemplateDetailComponent,
			'list-inventory-resume-component': ListInventoryResumeComponent,
		},
		mounted () {
			this.initComponenetLocal()
		}
	}
</script>

<style scoped lang="scss">
</style>